import { render, staticRenderFns } from "./PrintActivities.vue?vue&type=template&id=1087687e"
import script from "./PrintActivities.vue?vue&type=script&lang=js"
export * from "./PrintActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports